export default {
  afterTaxSales: 'Ventas Netas',
  inventory: 'Inventario de ',
  paySheet: 'Nómina',
  purchases: 'Compras de ',
  section: 'Reportes',
  salesBeforeTax: 'Ventas Brutas',
  tabs: {
    consumption: 'Consumo',
    salesAndCosts: 'Ventas y compras',
    priceComparison: 'Comparativo por producto',
    providerPriceComparison: 'Comparativo historico por proveedor',
    purchasesTracking: 'Seguimiento de compras',
    recipesTracking: 'Seguimiento de recetas'
  },
  download: 'Descargar reporte',
  downloading: 'Descargando...',
  successfulDownload: 'El reporte se ha descargado con éxito',
  salesAndCosts: {
    title: 'Reporte mensual de ventas y compras',
    description: 'Descarga en formato CSV un resumen de ventas y compras por mes de tu restaurante.',
    chooseDateRange: 'Por favor selecciona un rango de fechas'
  },
  priceComparison: {
    title: 'Comparativo por precio, variante y proveedor',
    description: 'Descarga un comparativo de las últimas 18 semanas sobre el precio del producto seleccionado por variante y proveedor.',
    chooseProduct: 'Por favor selecciona un producto',
    products: 'Productos',
    generateComparative: 'Generar comparativo',
    success: 'Se ha generado correctamente el comparativo',
    results: 'Resultados',
    table: {
      headers: {
        date: 'Fecha',
        product: 'Producto',
        unit: 'Unidad',
        unitPrice: 'Precio unitario',
        provider: 'Proveedor',
        category: 'Categoría',
        aliases: 'Alias'
      }
    }
  },
  providerPriceComparison: {
    title: 'Comparativo histórico de precio y variante por proveedor',
    description: 'Descarga un comparativo de las últimas 18 semanas de precio y variante por proveedor.',
    chooseProvider: 'Por favor selecciona un proveedor',
    providers: 'Proveedores'
  },
  purchasesTracking: {
    title: 'Seguimiento de compras',
    description: 'Descarga un reporte del seguimiento de compras de un rango de fechas para conocer el precio promedio, último precio y cantidad total comprada por producto.',
    chooseInterval: 'Por favor selecciona un rango de fechas',
    intervals: {
      label: 'Intervalo',
      weekly: 'Semanal',
      monthly: 'Mensual'
    }
  },
  recipesTracking: {
    title: 'Seguimiento de recetas',
    description: 'Descarga un reporte del seguimiento de recetas dado un rango de fechas.',
    chooseDateRange: 'Por favor selecciona un rango de fechas'
  },
  consumption: {
    title: 'Consumo',
    description: 'Descarga un reporte del consumo por producto dado un rango de fechas',
    chooseDateRange: 'Por favor selecciona un rango de fechas'
  }
}
